import { ResponsePasswordCreate, RequestPasswordCreate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { PasswordCreateActions } from '../actions';
import { PasswordCreateTypes } from '../../shared/enums';

export interface PasswordCreateState {
    response: ResponsePasswordCreate;
    request: RequestPasswordCreate;
    error: any;
}

export const PasswordCreateInitialState: PasswordCreateState = {
    response: null,
    request: null,
    error: null
};

const _passwordCreateReducer = createReducer(
    PasswordCreateInitialState,

    on(PasswordCreateActions.getPasswordCreate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(PasswordCreateActions.getPasswordCreateSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(PasswordCreateActions.getPasswordCreateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(PasswordCreateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function passwordCreateReducer(state, action) {
    if (action.type === PasswordCreateTypes.PASSWORD_CREATE) {
        state = undefined;
    }
    return _passwordCreateReducer(state, action);
}
